import { takeLatest } from "redux-saga/effects";
import { AddToCart, CreateOrder, GetCart, OrderGetComments } from "./Action";
import { apis } from "../../config/apis";
import { sagaFunctions } from "../../config/helper";
import { Addresses, Regions, Products } from "./Action";
import {
  DeleteItemFromCart,
  GetOrder,
  GetOrders,
  OrderAddComments,
  OrderHistory,
  OrderRepeat,
  OrderUpdate,
  ProductFilters,
  UpdateCart,
} from ".";

function addresses(req) {
  return sagaFunctions(Addresses, "get", apis.addresses, req.payload)();
}

function orders(req) {
  return sagaFunctions(GetOrders, "get", apis.orders, req.payload)();
}

function regions(req) {
  return sagaFunctions(Regions, "get", apis.zones, req.payload)();
}

function products(req) {
  return sagaFunctions(
    Products,
    req.payload.filters ? "post" : "get",
    req.payload.filters ? apis.filter_prods : apis.products,
    req.payload
  )();
}

function add_to_cart(req) {
  return sagaFunctions(AddToCart, "post", apis.line_items, req.payload)();
}

function create_order(req) {
  return sagaFunctions(CreateOrder, "post", apis.orders, req.payload)();
}

function get_cart(req) {
  return sagaFunctions(
    GetCart,
    "get",
    apis.carts + "/" + localStorage.getItem("cartId"),
    req.payload
  )();
}

function get_prod_filters(req) {
  return sagaFunctions(
    ProductFilters,
    "get",
    apis.admin.product_filters,
    req.payload
  )();
}

function update_cart(req) {
  let id = req.payload.product_id;
  delete req.payload.product_id;
  return sagaFunctions(
    UpdateCart,
    "post",
    apis.update_line_items(id),
    req.payload
  )();
}

function delete_from_cart(req) {
  let id = req.payload.id;
  delete req.payload.id;
  return sagaFunctions(
    DeleteItemFromCart,
    "post",
    apis.line_items + "/" + id,
    req.payload
  )();
}

function order(req) {
  let id = req.payload.id;
  delete req.payload.id;
  return sagaFunctions(GetOrder, "get", apis.orders + "/" + id, req.payload)();
}

function updateOrder(req) {
  return sagaFunctions(
    OrderUpdate,
    "post",
    `${apis.update_order}?email=${localStorage.getItem(
      "email"
    )}`,
    req.payload
  )();
}

function orderRepeat(req) {
  return sagaFunctions(
    OrderRepeat,
    "post",
    `${apis.order_repeat}?email=${localStorage.getItem(
      "email"
    )}`,
    req.payload
  )();
}

function orderAddComments(req) {
  return sagaFunctions(
    OrderAddComments,
    "post",
    `${apis.add_comments}?admin=true&email=${localStorage.getItem(
      "email"
    )}&authentication_token=${localStorage.getItem("token")}`,
    req.payload
  )();
}

function orderHistory(req) {
  return sagaFunctions(OrderHistory, "get", apis.order_history, req.payload)();
}

function orderGetComments(req) {
  return sagaFunctions(OrderGetComments, "get", apis.get_comments, req.payload)();
}

export function* ordersWatcher() {
  yield takeLatest(Addresses.REQUEST, addresses);
  yield takeLatest(OrderAddComments.REQUEST, orderAddComments);
  yield takeLatest(OrderGetComments.REQUEST, orderGetComments);
  yield takeLatest(OrderHistory.REQUEST, orderHistory);
  yield takeLatest(OrderUpdate.REQUEST, updateOrder);
  yield takeLatest(Regions.REQUEST, regions);
  yield takeLatest(Products.REQUEST, products);
  yield takeLatest(AddToCart.REQUEST, add_to_cart);
  yield takeLatest(GetCart.REQUEST, get_cart);
  yield takeLatest(CreateOrder.REQUEST, create_order);
  yield takeLatest(DeleteItemFromCart.REQUEST, delete_from_cart);
  yield takeLatest(GetOrders.REQUEST, orders);
  yield takeLatest(GetOrder.REQUEST, order);
  yield takeLatest(UpdateCart.REQUEST, update_cart);
  yield takeLatest(ProductFilters.REQUEST, get_prod_filters);
  yield takeLatest(OrderRepeat.REQUEST, orderRepeat);
}
